export function validatePositionPriceTrail(amount) {
  if (amount <= 0) return [false, 'Trail amount must be larger than zero.'];
  return [true, ''];
}
